import Joi from "joi";
import {
  MaintenanceTaskRecurrence,
  OrgMaintenanceTaskInput,
} from "../../../graphql/generated";

const recurrenceSchema = Joi.object<MaintenanceTaskRecurrence>({
  frequency: Joi.string().required().label("Frequency"),
  interval: Joi.number().allow(null).label("Interval"),
});

export const orgMaintenanceTaskSchema = Joi.object<OrgMaintenanceTaskInput>({
  label: Joi.string().required().label("Label"),
  startDate: Joi.date().allow(null).label("Start Date"),
  endDate: Joi.date().allow(null).label("End Date"),
  recurrence: recurrenceSchema.allow(null).label("Recurrence"),
  status: Joi.string().allow(null).label("Status"),
  assignedTo: Joi.string().allow(null).label("Assigned to"),
  alertBeforeDays: Joi.number().allow(null).label("Alert before days"),
});
